export default __webpack_public_path__ + "static/logo.alupress-388ea2c3035d6f0fa885f58716e52ea3.png";